<script lang="ts">
    import {api} from 'src/services/api/reallis'
    import unit1 from 'src/components/main/home/components/audience/unit-1.svg'
    import unit2 from 'src/components/main/home/components/audience/unit-2.svg'
    import unit3 from 'src/components/main/home/components/audience/unit-3.svg'
    import unit4 from 'src/components/main/home/components/audience/unit-4.svg'
    import unit5 from 'src/components/main/home/components/audience/unit-5.svg'
    import unit6 from 'src/components/main/home/components/audience/unit-6.svg'
    import planet from 'src/components/main/home/components/audience/planet.svg'

    let audience = getAudience()

    async function getAudience() {
        let result = await api.ws.ws1.request({
            data: {
                agent: "user",
                auth: {type: "webSite"},
                lang: "en",
                method: "profile_getNum",
                params: {}
            }
        })
        return (result.result.response.value - result.result.response.value % 1000).toLocaleString()
    }
</script>

<section style="--Planet:url({planet});">
    <div class="container">
        <div class="audience">
            <img src="{unit1}" class="unit unit-1" alt="">
            <img src="{unit2}" class="unit unit-2" alt="">
            <img src="{unit3}" class="unit unit-3" alt="">
            <img src="{unit4}" class="unit unit-4" alt="">
            <img src="{unit5}" class="unit unit-5" alt="">
            <img src="{unit6}" class="unit unit-6" alt="">
            <div class="text">Our audience is already more than</div>
            <div class="count">
                {#await audience}
                    Loading...
                {:then count}
                    {count}+
                {/await}
            </div>
        </div>
    </div>
</section>

<style>
    section {
        background: var(--Planet) no-repeat center;
        background-size: auto;
        height: 1500px;
        margin: -200px 0 -350px;
    }

    .audience {
        text-align: center;
        font-family: "Echoes Sans", sans-serif;
        font-weight: 600;
        padding-top: 515px;
        white-space: nowrap;
        position: relative;
    }

    .text {
        font-size: 30px;
        color: #CED5E3;
        margin-bottom: 82px;
    }

    .count {
        color: white;
        font-size: 170px;
        font-family: 'Anton', sans-serif;
        letter-spacing: 15px;
        line-height: 1;
    }

    .unit {
        position: absolute;
        left: 50%;
        top: 50%;
    }

    .unit-1 {
        margin: -110px 0 0 -390px;
    }

    .unit-2 {
        margin: 20px 0 0 -630px;
    }

    .unit-3 {
        margin: 350px 0 0 -560px;
    }

    .unit-4 {
        margin: -50px 0 0 330px;
    }

    .unit-5 {
        margin: 220px 0 0 505px;
    }

    .unit-6 {
        margin: 420px 0 0 380px;
    }

    @media(max-width: 1400px) {
        section {
            margin: -250px 0 -500px;
        }

        .count {
            font-size: 150px;
        }

        .unit-1 {
            margin: -110px 0 0 -360px;
            width: 126px;
        }

        .unit-2 {
            margin: 20px 0 0 -570px;
            width: 180px;
        }

        .unit-4 {
            width: 180px;
        }

        .unit-5 {
            margin: 220px 0 0 440px;
            width: 150px;
        }

        .unit-6 {
            margin: 430px 0 0 370px;
            width: 110px;
        }
    }

    @media(max-width: 1200px) {
        section {
            margin: -350px 0 -500px;
            background-size: cover;
            overflow: hidden;
        }

        .audience {
            padding-top: 550px;
        }

        .text {
            font-size: 24px;
        }

        .count {
            font-size: 100px;
        }

        .unit-1 {
            margin: 0 0 0 -300px;
            width: 110px;
        }

        .unit-2 {
            margin: 120px 0 0 -470px;
            width: 150px;
        }

        .unit-3 {
            margin: 350px 0 0 -415px;
            width: 70px;
        }

        .unit-4 {
            width: 150px;
            margin: 30px 0 0 240px;
        }

        .unit-5 {
            margin: 240px 0 0 340px;
            width: 130px;
        }

        .unit-6 {
            margin: 410px 0 0 250px;
            width: 90px;
        }
    }

    @media (max-width: 992px) {
        section {
            margin: -350px 0 -500px;
            background-size: 1200px;
            height: 1200px;
        }

        .audience {
            padding-top: 430px;
        }

        .text {
            font-size: 20px;
            line-height: normal;
        }

        .count {
            font-size: 80px;
            letter-spacing: 10px;
        }

        .unit-1 {
            margin: 0 0 0 -230px;
            width: 90px;
        }

        .unit-2 {
            margin: 90px 0 0 -360px;
            width: 110px;
        }

        .unit-3 {
            margin: 280px 0 0 -320px;
            width: 50px;
        }

        .unit-4 {
            width: 110px;
            margin: 30px 0 0 215px;
        }

        .unit-5 {
            margin: 190px 0 0 265px;
            width: 100px;
        }

        .unit-6 {
            margin: 320px 0 0 210px;
            width: 70px;
        }
    }

    @media (max-width: 767px) {
        section {
            margin: -220px 0 -300px;
            background-size: 900px;
            height: 900px;
        }

        .audience {
            padding-top: 330px;
        }

        .text {
            font-size: 16px;
            margin-bottom: 50px;
        }

        .count {
            font-size: 60px;
        }

        .unit-1 {
            margin: 0 0 0 -170px;
            width: 70px;
        }

        .unit-2 {
            margin: -30px 0 0 -30px;
            width: 50px;
        }

        .unit-3 {
            margin: 270px 0 0 -180px;
            width: 40px;
        }

        .unit-4 {
            width: 70px;
            margin: 20px 0 0 110px;
        }

        .unit-5 {
            margin: 300px 0 0 -40px;
            width: 60px;
        }

        .unit-6 {
            margin: 280px 0 0 110px;
            width: 60px;
        }
    }
</style>
